import { isEmpty } from "@swiggy-private/js-utils";
import { IRewardWidgetResponseData } from "@dineout-cart-client/interfaces";

export const getIsRewardRedeemed = (rewardsWidget?: IRewardWidgetResponseData): boolean =>
    rewardsWidget?.rewardsRedeemed || false;

export const getRedeemableRewards = (rewardsWidget?: IRewardWidgetResponseData): number =>
    rewardsWidget?.redeemableRewards || 0;

export const getIsRestaurantHaving2xDineCash = (rewardsWidget?: IRewardWidgetResponseData): boolean =>
    Boolean(rewardsWidget?.isBooster) && !isEmpty(rewardsWidget?.header);

export const getRewardsTogglePayload = (rewardsWidget?: IRewardWidgetResponseData) => ({
    cashbackSpent: rewardsWidget?.redeemableRewards || 0,
    cashbackEarned: rewardsWidget?.earnedRewards || 0,
    remainingBalance: rewardsWidget?.redeemableRewards || 0,
    isRestaurantHaving2xDineCash: getIsRestaurantHaving2xDineCash(rewardsWidget),
});
